import React, { useEffect, Fragment, useState, useRef } from 'react'
import { Button, Modal, Card, Row, Col, Form, OverlayTrigger, Tooltip, Table } from 'react-bootstrap'
import { LoadingComponent } from 'recupero-comunes';
import { getAntecedentesCaso, serviceGetImplicados, serviceGetInforme, serviceGetDatosImplicado } from '../../api/api-consulta-gestion-entre-cias';
import { descargarArchivo } from '../../common/descargarArchivo';
import { FaSearch } from "react-icons/fa";
import { formatoMonto } from '../../common/Formatos';


const ConsultaGestionEntreCias = ({ idCaso, idOrgCaso, showModal, setShowModal }) => {
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState([]);
    const [implicados, setImplicados] = useState([]);

    const [stateImplicado, setStateImplicado] = useState("");
    const [stateTodos, setStateTodos] = useState(false);
    const [datosImplicado, setDatosImplicado] = useState({});
    const [antecedentesCaso, setAntecedentesCaso] = useState(false);

    const [recuperoDirecto, setRecuperoDirecto] = useState(false);
    const [recuperoCIAS, setRecuperoCIAS] = useState(false);
    const [defensaDirecta, setDefensaDirecta] = useState(false);
    const [defensaCIAS, setDefensaCIAS] = useState(false);

    useEffect(() => {
        if (showModal) getImplicados();
    }, [showModal])

    const handleImplicado = (value) => {
        setStateImplicado(value);
        if (value !== "") { setStateTodos(false); setData([]) }
    }

    const handleTodos = (value) => {
        setStateTodos(value);
        if (value) { setStateImplicado(""); setData([]) }
    }

    const handleClose = () => {
        setShowModal(false);
        setStateTodos(false);
        setStateImplicado("");
        setData([]);
    }

    const getImplicados = async () => {
        setLoading(true);
        const query = Buffer.from(JSON.stringify({ idOrgCaso: idOrgCaso, idCaso: idCaso })).toString('base64');
        const response = await serviceGetImplicados(query);

        if (response && response.length == 1) {
            setStateImplicado(1);
            getDatosImplicado(1);
        }

        setImplicados(response);
        
        getDatosCaso();
    }
    const getDatosCaso = async () => {
        const query = Buffer.from(JSON.stringify({ idOrgCaso: idOrgCaso, idCaso: idCaso })).toString('base64');
        const antecedentesCaso = await getAntecedentesCaso(query);

        let responsableEsAbogado = antecedentesCaso && antecedentesCaso.length > 0 ? antecedentesCaso[0].responsableEsAbogado : 0;
        let idTipoGestion = antecedentesCaso && antecedentesCaso.length > 0 ? antecedentesCaso[0].IdTipoGestion : 0;

        //console.log("responsableEsAbogado: ", responsableEsAbogado);
        //console.log("idTipoGestion: ", idTipoGestion);
        
        setRecuperoDirecto(true);//let flujoGestion = 235002; //Recupero Directo

        if (idTipoGestion == 207001 && !responsableEsAbogado) {
            setRecuperoCIAS(true);//flujoGestion = 235001;//Recupero entre CIAs
            setRecuperoDirecto(false);
            setDefensaDirecta(false);
            setDefensaCIAS(false);
        } else {
            if (idTipoGestion == 207002 && !responsableEsAbogado) {
                setDefensaCIAS(true);//flujoGestion = 235005;//Defensa entre CIAs
                setRecuperoCIAS(false);
                setRecuperoDirecto(false);
                setDefensaDirecta(false);
            } else {
                if (idTipoGestion == 207002) {
                    setDefensaDirecta(true);//flujoGestion = 235003;//Defensa directa
                    setDefensaCIAS(false);
                    setRecuperoCIAS(false);
                    setRecuperoDirecto(false);
                }
            }
        }
        setAntecedentesCaso(antecedentesCaso);
        setLoading(false);
    }
    const handleInforme = async () => {
        if (datosImplicado?.idfolioCargaDocto) {
            setLoading(true); 
            let query = Buffer.from(JSON.stringify({
                idCaso: idCaso,
                idImplicadoCaso: datosImplicado?.IdImplicado,
                idCompania: idOrgCaso,
                idfolioCarga: datosImplicado?.idfolioCargaDocto
            })).toString('base64')

            const response = await serviceGetInforme(query);
            setLoading(false);

            descargarArchivo(response);
        }
    }
    const getDatosImplicado = async (idImplicado) => {
        if (idImplicado != "") {
            setLoading(true); 
            const query = Buffer.from(JSON.stringify({ idCaso: idCaso, idImplicado: idImplicado })).toString('base64');
            const response = await serviceGetDatosImplicado(query);

            setDatosImplicado(response && response.length > 0 ? response[0] : null);
            setLoading(false); 
    
        } else {
            setStateImplicado("");
            setDatosImplicado({})
        }
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showModal} onHide={handleClose} size='xl'>
                <Card>
                    <Card.Header className='cardHeader'>
                        {(recuperoCIAS || recuperoDirecto) ? "CONSULTA RECOBRO A CIA TERCERO" : "CONSULTA PAGO A CIA TERCERO"} - {idCaso}
                    </Card.Header>
                    <Card.Body style={{ padding: '10px 20px' }}>
                        <Row>
                            <Col md='4'>
                                <Form.Label>
                                    Seleccione Implicado
                                </Form.Label>
                                <Form.Select
                                    name='stateImplicado'
                                    onChange={(e) => {handleImplicado(e.target.value), getDatosImplicado(e.target.value)}}
                                    value={stateImplicado}>

                                    <option value={""}>Seleccione</option>
                                    {implicados && implicados
                                        .map((i, index) => (<option key={index} value={i.IdImplicado}>{i.NombreImplicadoCmb}</option>))
                                    }
                                </Form.Select>
                            </Col>
                        </Row>
                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>
                        {stateImplicado !== "" &&
                            <div>
                                <Card className='mt-1'>
                                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}>
                                        {(recuperoCIAS || recuperoDirecto) ? "Envío Carta Cobro" : "Recepción Carta Cobro"}
                                    </Card.Header>   
                                    <Card.Body style={{ padding: '10px 20px' }}>
                                        <Row>
                                            <Col md='2'>
                                                <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    Compañía
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                    {datosImplicado && datosImplicado.CiaImplicado}
                                                </Form.Text>
                                            </Col>
                                            <Col md='2'>
                                                <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    Siniestro CIA IM
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                    {datosImplicado && datosImplicado.SiniestroIM}
                                                </Form.Text>
                                            </Col>
                                            <Col md='3'>
                                                <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    Fecha Siniestro IM
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                    {datosImplicado && datosImplicado.FechaSiniestroIMFormat}
                                                </Form.Text>
                                            </Col>
                                            <Col md='3'>
                                                <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    Fecha {(recuperoCIAS || recuperoDirecto) ? "envío" : "recepción"} Carta
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                    {datosImplicado && datosImplicado.FechaEnvioCartaCobroFormat}
                                                </Form.Text>
                                            </Col>
                                            <Col md='2'>
                                                <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    Estado
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                    {datosImplicado && datosImplicado.EstadoImplicado}
                                                </Form.Text>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md='2'>
                                                <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    Moneda
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                    {datosImplicado && datosImplicado?.GlosaMonedaRecobro}
                                                </Form.Text>
                                            </Col>
                                            <Col md='2'>
                                                <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    Monto Neto
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                    {datosImplicado && formatoMonto(datosImplicado.MontoCosto)}
                                                </Form.Text>
                                            </Col>
                                            <Col md='3'>
                                                <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    % Convenio
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                    {datosImplicado && datosImplicado.PorConvenido}
                                                </Form.Text>
                                            </Col>
                                            <Col md='3'>
                                                <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    Monto Cobro
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                    {datosImplicado && formatoMonto(datosImplicado.MontoRecobro)}
                                                </Form.Text>
                                            </Col>
                                            <Col md='2'>
                                                <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    Ver Carta
                                                </Form.Label>
                                                <br />
                                                <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>{datosImplicado?.idfolioCargaDocto ? "Ver Carta" : "No existe Carta"}</Tooltip>}>
                                                    <Button variant='light'>
                                                        <FaSearch
                                                            size={20}
                                                            color='gray'
                                                            onClick={handleInforme}
                                                        />
                                                    </Button>
                                                </OverlayTrigger>
                                            </Col>
                                        </Row>
                                    </Card.Body>        
                                </Card>
                                {defensaCIAS &&
                                    <Card className='mt-1'>
                                        <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}>
                                            Aprobación u Objeción
                                        </Card.Header>   
                                        <Card.Body style={{ padding: '10px 20px' }}>
                                            <Row>
                                                <Col md='3'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Clasifica Respuesta
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.GlosaClasRpta}
                                                    </Form.Text>
                                                </Col>
                                                <Col md='3'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Motivo
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.MotivoRespuestaCarta}
                                                    </Form.Text>
                                                </Col>
                                                <Col md='3'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Fecha Respuesta
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.FechaRespuestaCartaFormat}
                                                    </Form.Text>
                                                </Col>
                                                <Col md='3'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Tipo Siniestro IM
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.GlosaTipoSiniestroIM}
                                                    </Form.Text>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md='3'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Neto Aprobado
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && formatoMonto(datosImplicado?.MontoNetoApr)}
                                                    </Form.Text>
                                                </Col>
                                                <Col md='3'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        % Convenio Aprobado
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.PorcConvAprob}
                                                    </Form.Text>
                                                </Col>
                                                <Col md='3'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Monto Cobro Aprobado
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && formatoMonto(datosImplicado.RecobroAprob)}
                                                    </Form.Text>
                                                </Col>                                                
                                            </Row>
                                            <Row>
                                                <Col md='6'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Comentario Analista
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.ComentarioAnalista}
                                                    </Form.Text>
                                                </Col> 
                                                <Col md='6'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Destinatarios
                                                    </Form.Label>
                                                    <br />
                                                    <Table style={{ borderWidth: '0px' }}>
                                                        {datosImplicado &&
                                                            datosImplicado?.destNotificaCartaCIAS?.map((destinatario, index) => {
                                                                return (
                                                                        <tr key={index}>
                                                                            <td style={{ fontSize: '14px', color: '#6c757d' }}>{destinatario.emailDestinatario}</td>
                                                                        </tr>
                                                                )
                                                            })
                                                        }
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </Card.Body>        
                                    </Card>
                                }
                                {recuperoCIAS &&
                                    <Card className='mt-1'>
                                        <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}>
                                            Aprobación u Objeción
                                        </Card.Header>   
                                        <Card.Body style={{ padding: '10px 20px' }}>
                                            <Row>
                                                <Col md='3'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Clasifica Respuesta
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.GlosaClasRpta}
                                                    </Form.Text>
                                                </Col>
                                                <Col md='2'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Motivo
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.MotivoRespuestaCarta}
                                                    </Form.Text>
                                                </Col>
                                                <Col md='2'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Fecha Respuesta
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.FechaRespuestaCartaFormat}
                                                    </Form.Text>
                                                </Col>
                                                <Col md='2'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        % Convenio Aprobado
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.PorConvenido}
                                                    </Form.Text>
                                                </Col>
                                                <Col md='3'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Monto Cobro Aprobado
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && formatoMonto(datosImplicado.MontoRecobro)}
                                                    </Form.Text>
                                                </Col>                                                
                                            </Row>
                                            <Row>
                                                <Col md='5'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Destinatario CIA
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.EmailDestinatarioCIA}
                                                    </Form.Text>
                                                </Col>
                                                <Col md='7'>
                                                    <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Comentario Analista
                                                    </Form.Label>
                                                    <br />
                                                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                                                        {datosImplicado && datosImplicado.ComentarioAnalista}
                                                    </Form.Text>
                                                </Col> 
                                            </Row>
                                        </Card.Body>        
                                    </Card>
                                }
                            </div>
                        }
                        <br></br>
                        <Col className="d-grid d-md-flex justify-content-md-end mb-2">
                            <Button style={{ width: '110px', marginRight: '5px' }} variant='outline-info' onClick={handleClose}>Volver</Button>
                        </Col>                        
                    </Card.Body>
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                    .table>:not(:first-child) {
                        border-top: none;
                    }
                    .customSearch {
                        color: #fff;
                        background-color: #ffc107;
                        border-color: #ffc107;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default ConsultaGestionEntreCias